var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',[_c('span',{staticClass:"mx-2 font-weight-light"},[_vm._v(" Welcome ")]),_c('span',{staticClass:"text-h6 font-italic primary--text"},[_vm._v(" "+_vm._s(_vm.user.name)+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }